export default __webpack_public_path__ + "static/media/background2.6ac5d8ab.jpg";